import { NudosGenericModal, NudosModalContent } from '../../../../NudosComponents';
import ExternalWipingModalContent from './ExternalWipingModalContent';

import './ExternalWipingModal.scss';

const ExternalWipingModal = ({
  closeModal,
  markExternalWiping
}: {
  closeModal: () => void;
  markExternalWiping: (file?: File, loadingHandler?: React.Dispatch<React.SetStateAction<boolean>>) => Promise<void>;
}) => {
  return (
    <div className="externalWipingModal">
      <NudosGenericModal
        closeModalCallback={closeModal}
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight="426px"
            modalContentTitle="Marcar como Wiping a Bodegas"
            toCloseModal={closeModal}
            CustomModalComponent={<ExternalWipingModalContent markExternalWiping={markExternalWiping} />}
          />
        }
      />
    </div>
  );
};

export default ExternalWipingModal;
